import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ISignal, RolePermissionsModel, ValidationRules } from '../../../../shared/models/app.model';
import { catchError, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { CommonService } from '../../../../shared/services/common.service';
import { UserProfileService } from '../../services/user-profile.service';
import { PROFILE_SOURCES, profileModificationModel, UPEnums, UPGeneralFields } from '../../model/user-profile.model';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { ActionIconDef, Grid, GridActionIconClickEvent, GridConfig, GridToolbarActionClickEvent } from '@inavista/components/grid';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { UP_ADDRESSES_SCHEMA, UP_ADDRESSES_URL, upAddressesActionIcons, upAddressesGridConfig, upAddressesToolbarActions } from './up-general-addresses.grid.config';
import { dateFormats } from '../../../../shared/models/utils/date-functions';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { REGEXES, UserRoles } from 'projects/sales/src/app/shared/constants/app.constants';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';
import { DroApiService } from 'projects/shared/src/lib/dro/dro-api.service';
import { TimeZoneOption, UserTimeZoneView } from 'projects/shared/src/lib/dro/dro.models';

let MASTER_API_URL = '';

@Component({
    selector: 'app-up-general',
    templateUrl: './up-general.component.html',
    styleUrls: ['./up-general.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    // The Addresses grid's rows are the section's own (LocalRowsGridApi); the address search popup reaches the server.
    providers: [...provideLocalGridRows()],
    standalone: false
})
export class UpGeneralComponent implements OnInit, AfterViewInit, OnDestroy {
  showAddAddressesPopup: boolean = false;
  addressesGridConfig: GridConfig | null = null;
  addressesActionIcons: ActionIconDef[] = [];
  private readonly addressRows = inject(LocalRowsGridApi);
  // Time zone (DB-013): the calendar day of dated actions such as a DRO reading. Empty = the company's zone. Shown when
  // RIMS Master api/user-time-zone answers for this user (one's own, or a role that edits user profiles); saved with Save.
  private readonly droApi = inject(DroApiService);
  timeZone: UserTimeZoneView | null = null;
  timeZones: TimeZoneOption[] = [];
  timeZoneValue = '';
  private timeZoneChanged = false;
  employeeAddresses: any[] = [];

  @ViewChild('generalEnableCb') public generalEnableCb!: CheckBoxComponent;
  @ViewChild('profilePictureUpload') public uploader!: UploaderComponent;
  @Input('reloadSection') reloadSection: boolean = false;
  @Input('userId') userId: any = ''; // for my profile, userId is gonna be '' // userId to be sent empty for other APIs.
  @Input('userProfile') userProfile: any; // for my profile userId in this object will be an Id. userId to be sent for permissions apis.
  @Input('source') source: PROFILE_SOURCES = UPEnums.SourceUser;
  @Input() actions: Subject<ISignal>;
  @Output() isUserActiveOutput = new EventEmitter();
  @Output() genUserDataOutput = new EventEmitter();
  @Output() profileModified = new EventEmitter<profileModificationModel>();
  UPGeneralFields: typeof UPGeneralFields = UPGeneralFields;
  UserRoles: typeof UserRoles = UserRoles;
  UserProfileService: typeof UserProfileService = UserProfileService;
  UPEnums: typeof UPEnums = UPEnums;
  generalForm: FormGroup<any>;
  private destroy$: Subject<any>;
  isFormSubmitted: boolean = false;


  todayDate: Date = new Date(Date.now());
  INITIALS: any;
  defaultAvatar: string = 'assets/img/user-profile/avatar.jpg';
  pictureURL: string = '';

  public path: Object;
  @ViewChild('AddressesGrid') AddressesGrid?: Grid;
  modifiedUI: any = {};
  PERMISSIONS: RolePermissionsModel[] = [];
  isCreatingNewUser: boolean = false;
  isSectionEnabled: boolean = true;
  // Get all Syncfusion textboxes in the component
  @ViewChildren(TextBoxComponent) textBoxes!: QueryList<TextBoxComponent>;
  countriesList: any = []
  USER: any;
  signatureImage: string = '';
  showEditSignaturePopup: boolean = false;

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private fb: FormBuilder, 
    private commonService: CommonService, 
    private usersService: UserProfileService, 
    private authService: AuthService
  ) {
    this.generalForm = this.fb.group({});
    this.modifiedUI[UPEnums.GeneralFormData] = false;
    this.modifiedUI[UPEnums.GeneralProfilePic] = false;
    this.modifiedUI[UPEnums.GeneralAddresses] = false;
    this.actions = new Subject();
    this.destroy$ = new Subject();
    MASTER_API_URL = this.config.masterApiURL;
    this.path = {
    saveUrl: `${MASTER_API_URL}FileManagement/UploadTemp`,
    removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove'
  };
  }
  ngAfterViewInit(): void {
    this.refreshAddressRows();
  }

  ngOnInit() {
    console.log("DOn => 23F3pm")
    this.USER = this.commonService.getUSER();
    this.isCreatingNewUser = (!this.userId && this.source == UPEnums.SourceUser);
    this.handleSubjects();
    this.loadPermissions();
    this.handleActions();
    this.initForm();
    this.getGeneralData();
    this.handleDateChanges();
  }
  handleDateChanges() {
    this.generalForm.get(UPGeneralFields.startDate)!.valueChanges.subscribe(value => this.usersService.setMinStartDate(value));
    this.generalForm.get(UPGeneralFields.endDate)!.valueChanges.subscribe(value => this.usersService.setMinEndDate(value));
  }
  handleSubjects() {
    this.usersService.copyDataToGeneral.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      const pEmail = res[UPGeneralFields.primaryEmail];
      const pMobile = res[UPGeneralFields.primaryMobile];
      const address = res['newAddress'];
      // const countryId = (address && address[UPGeneralFields.countryId]) || '';
      address?.addressCode && this.onAddressesPopupClose(address);
      pEmail && pEmail != '' && this.generalForm.get(UPGeneralFields.primaryEmail).setValue(pEmail);
      pMobile && pMobile != '' && this.generalForm.get(UPGeneralFields.primaryMobile).setValue(pMobile);
      // countryId && countryId != '' && this.generalForm.get(UPGeneralFields.countryId).setValue(countryId);
      (!!pEmail || !!pMobile || !!address?.addressCode) && this.sectionModified({modified: true, section: UPEnums.GeneralFormData });
    });
    this.usersService.saveCopiedDataToGeneral.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.saveProfile('');
    });
  }
  // =============================================================================================================================
  // =============================================================================================================================
  // =====================================================  COMMON FUNCTIONS BELOW
  // =============================================================================================================================
  // =============================================================================================================================
  loadPermissions(
    category: string = this.source == UPEnums.SourceMyProfile ? UPEnums.MPGeneralPermission : UPEnums.UPGeneralPermission  ,
    subCategory: string = '',
    id: string = this.userProfile?.[UPGeneralFields.userId],
    module: string = 'userProfile'
  ) {
    this.usersService.apiCallStarted("loadPermissions_General");
    this.commonService.getRolePermission(category, subCategory, module, id).subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        this.PERMISSIONS.map((permission: RolePermissionsModel) => {
          permission.ruleAction = permission.ruleAction.replace('MP_', '').replace('UP_', '');
        });
        this.updatePagePermissions().then(() => {
          this.usersService.apiCallCompleted("loadPermissions_General");
        });
      },
      error: (err: any) => {
        this.PERMISSIONS = [];
        this.usersService.apiCallCompleted("loadPermissions_General");
      }
    });
  }
  updatePagePermissions(): Promise<boolean> {
    return new Promise((resolve) => {
      [
        { control: UPGeneralFields.userId, rule: 'Gen_rimsId' },
        { control: UPGeneralFields.name, rule: 'Gen_userName' },
        { control: UPGeneralFields.userName, rule: 'Gen_userId' },
        { control: UPGeneralFields.startDate, rule: 'Gen_startDate' },
        { control: UPGeneralFields.endDate, rule: 'Gen_endDate' },
        { control: UPGeneralFields.primaryEmail, rule: 'Gen_globalEmail' },
        { control: UPGeneralFields.countryId, rule: 'Gen_globalEmail' },
        { control: UPGeneralFields.primaryMobile, rule: 'Gen_globalMobile' },
        { control: UPGeneralFields.isEnabled, rule: 'Gen_gloablEnable'},
        { control: UPGeneralFields.lastLogin, rule: 'Gen_lastLogin' },
        { control: UPGeneralFields.isSSO, rule: 'Gen_SSO' },
      ]
        .forEach((e) => { this.updateUIElement(e.control, e.rule) });
        this.buildAddressesGrid();
        resolve(true);
    });
  }
  getFieldValue(field: string) {
    let val = this.generalForm.controls[field]?.value;
    typeof(val) == 'string' && (val = val.trim());
    return val;
  }
  getDateFormat() {
    return dateFormats.MDY;
  }
  updateUIElement(control: string, rule: string) {
    const RULE = this.getPermission(rule);
    if(!RULE) {
      // console.log("This permission is missing in DB: ", rule);
    } else {
      if(rule == 'Gen_gloablEnable') {
        // const isDisabled = (!RULE?.enable || RULE?.readOnly == true || !this.generalForm.get(UPGeneralFields.isEnabled).value);
        // this.usersService.setUserGlobbayDisabled(isDisabled);
        // isDisabled ?
        //   this.generalForm.controls[control].disable() :
        //   this.generalForm.controls[control].enable();
        (!!RULE?.required && !!RULE?.visible && !!this.userId) ?
          this.generalForm.controls[control].addValidators(Validators.required) :
          this.generalForm.controls[control].removeValidators(Validators.required);
      } else {
        (!RULE?.enable || !!RULE?.readOnly) ?
          this.generalForm.controls[control].disable() :
          this.generalForm.controls[control].enable();
        (!!RULE?.required && !!RULE?.visible) ?
          this.generalForm.controls[control].addValidators(Validators.required) :
          this.generalForm.controls[control].removeValidators(Validators.required);
      }
      this.generalForm.controls[control].updateValueAndValidity();
    }
  }

  get isEmailAddressValid() {
    let email = this.generalForm.controls[UPGeneralFields.primaryEmail].value;
    return email ? (ValidationRules.email.regex.test(this.generalForm.controls[UPGeneralFields.primaryEmail].value)) : true;
  }
  get isMobileNumberValid() {
    const phoneNumberRegex = ValidationRules.telephone.regex;
    let mobileNo = this.generalForm.controls[UPGeneralFields.primaryMobile].value;
    let check: boolean = mobileNo ? this.isFormSubmitted && mobileNo.replace(/[-()+#]\s/g, "")?.length > 9 && phoneNumberRegex.test(mobileNo) : true;
    return check;
  }
  get isSignatureEnabled() {
    return (this.getPermission('Gen_editUserSignature')?.enable && (!!this.userId || this.source === UPEnums.SourceMyProfile)) && this.isSectionEnabled;
  }
  get isSignatureDeletable() {
    return (this.getPermission('Gen_deleteUserSignature')?.enable && (!!this.userId || this.source === UPEnums.SourceMyProfile) && !!this.signatureImage && this.isSectionEnabled);
  }
  get isProfilePictureDeletable() {
    return (this.getPermission('Gen_deleteUserProfilePicture')?.enable && !!this.pictureURL && this.isSectionEnabled);
  }
  initForm() {
    this.generalForm.addControl(UPGeneralFields.userId, new FormControl(this.userId));
    this.generalForm.addControl(UPGeneralFields.name, new FormControl( ''));
    this.generalForm.addControl(UPGeneralFields.userName, new FormControl('', [Validators.pattern(/^[0-9a-zA-Z.@\-_]{1,255}$/)]));
    this.generalForm.addControl(UPGeneralFields.startDate, new FormControl<Date | null>(null));
    this.generalForm.addControl(UPGeneralFields.endDate, new FormControl<Date | null>(null));
    this.generalForm.addControl(UPGeneralFields.primaryEmail, new FormControl( ''));
    this.generalForm.addControl(UPGeneralFields.countryId, new FormControl(''));
    this.generalForm.addControl(UPGeneralFields.primaryMobile, new FormControl( ''));
    this.generalForm.addControl(UPGeneralFields.isEnabled, new FormControl(false));
    this.generalForm.addControl(UPGeneralFields.lastLogin, new FormControl(''));
    this.generalForm.addControl(UPGeneralFields.isSSO, new FormControl( false));
    this.userId = this.generalForm.controls[UPGeneralFields.userId]?.value;
    this.usersService.setFormsInUPService('general', this.generalForm);
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  getGeneralData() {
    this.isCreatingNewUser = (!this.userId && this.source == UPEnums.SourceUser);
    let apis = [this.commonService.getCountries()]
    if (this.isCreatingNewUser) { // Create NEW User
      this.pictureURL = '';
      this.assignNameInitialsInProfilePicture();
      this.usersService.setUserGlobbayDisabled(true);
      this.generalForm.controls[UPGeneralFields.isEnabled].disable();
    } else {
      this.usersService.apiCallStarted("getGeneralData");
      apis.push(this.usersService.getUserById(this.userId));
      apis.push(this.usersService.getUserProfileAddressById(this.userId));
      apis.push(this.usersService.getUserSignatureById(this.userId));
      apis.push(this.usersService.getUserPictureUrlById(this.userId));
    }
    apis = apis.map(api => api.pipe(catchError(error => of(error))));
    forkJoin(apis)
      .subscribe({
        next: (responses: any) => {
          this.countriesList = responses[0]?.result;
        if (!this.isCreatingNewUser) {
          responses[1]?.result && this.generalForm.patchValue(responses[1]?.result);
          this.isUserActiveOutput.emit(responses[1]?.result?.[UPGeneralFields.isEnabled]);
          this.genUserDataOutput.emit(responses[1]?.result);
          responses[1]?.result && (this.userProfile = responses[1]?.result);
          let lastLogin = this.generalForm.controls[UPGeneralFields.lastLogin];
          this.getFieldValue(UPGeneralFields.lastLogin) ? lastLogin.setValue(new Date(this.getFieldValue(UPGeneralFields.lastLogin)).toLocaleString()) : lastLogin.setValue('');
          const isDisabled = (!this.generalForm.get(UPGeneralFields.isEnabled).value);
          this.usersService.setUserGlobbayDisabled(isDisabled);
          // isDisabled ?
          //   this.generalForm.controls[UPGeneralFields.isEnabled].disable() :
          //   this.generalForm.controls[UPGeneralFields.isEnabled].enable();
          this.employeeAddresses = responses[2]?.result?.addresses;
          this.usersService.setGeneralAddressCodes(this.employeeAddresses);
          this.refreshAddressRows();
          this.signatureImage = (responses[3]?.result?.signature as string)?.trim();
        }
        this.pictureURL = this.isCreatingNewUser ? '' : responses[4]?.result?.pictureURL;
        this.assignNameInitialsInProfilePicture();
        !this.isCreatingNewUser && this.loadTimeZone();
        this.usersService.apiCallCompleted("getGeneralData");
        this.usersService.setMinStartDate(this.generalForm.get(UPGeneralFields.startDate).value);
        this.usersService.setMinEndDate(this.generalForm.get(UPGeneralFields.endDate).value);
        },
        error: (err: any) => {
          this.usersService.apiCallCompleted("getGeneralData");
        },
      });
  }
  focusToFirstElement() {
    // setTimeout(() => {
      const firstEnabledTextBox = document.getElementById('inputToFocusAt') as HTMLElement

    if (firstEnabledTextBox) {
      firstEnabledTextBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  // }, 400);
  }
  handleActions() {
    if (this.actions != null) {
      this.actions
        .pipe(takeUntil(this.destroy$))
        .subscribe((ac: ISignal) => {
          if (ac?.action === 'allSectionsLoaded') {
            this.focusToFirstElement();
          } else
          if (ac?.action === 'reloadPermissions'  && (ac?.data.category == UPEnums.UPGeneralPermission || ac?.data.category == UPEnums.MPGeneralPermission)) {
            this.loadPermissions(ac?.data?.category, ac?.data?.subCategory, ac?.data?.id, ac?.data?.module);
          } else
          if (ac?.action === 'checkValidations') {

            this.commonService.printInvalidControls(this.generalForm, 'up-general.ts');
            this.isFormSubmitted = true;
            [UPGeneralFields.name, UPGeneralFields.userName, UPGeneralFields.primaryEmail, UPGeneralFields.primaryMobile].forEach((item: any) => this.removeTrailingSpaces(item));
            const startDate = this.generalForm.get(UPGeneralFields.startDate)?.value;
            const endDate = this.generalForm.get(UPGeneralFields.endDate)?.value;
            if(this.usersService.areDatesInvalid()) {
             return;
            } else if (this.generalForm.invalid || !this.isMobileNumberValid || !this.isEmailAddressValid) {
              // console.log('Invalid Inputs in General Form are = ', Object.keys(this.generalForm.controls).filter((key) => this.generalForm.controls[key].status != "VALID"));
              this.usersService.setInvalidData(true, UPEnums.GeneralFormData);
              this.commonService.showNotification("info", "General: Please enter valid data!");
            } else {
              this.usersService.setInvalidData(false, UPEnums.GeneralFormData);
            }
          } else
          if (ac?.action === 'saveGeneralFormData') {
            if (UserProfileService.invalidDataCount < 1) {
              const saveFormData = this.modifiedUI[UPEnums.GeneralFormData] === true;
              if(saveFormData) {
                this.modifiedUI[UPEnums.GeneralFormData] = false;
                this.saveProfile(ac?.data);
              }
          }
          } else if (ac?.action === 'saveAll') {
          let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
          if(hasUnsavedChanges) {
              if (UserProfileService.invalidDataCount < 1) {
                const saveAddresses = this.modifiedUI[UPEnums.GeneralAddresses] === true;
                const saveProfilePic = this.modifiedUI[UPEnums.GeneralProfilePic] === true;

                const saveGeneralAddresses = () => {
                  if(this.generalForm.get(UPGeneralFields.userId).value) {
                    this.usersService.apiCallStarted(UPEnums.GeneralAddresses);
                    var payload = {
                      userId: this.generalForm.get(UPGeneralFields.userId)?.value,
                      addressCodes: this.employeeAddresses
                    };
                    this.usersService.saveUserProfileAddress(payload).subscribe({
                      next: (res: any) => {
                        this.usersService.apiCallCompleted(UPEnums.GeneralAddresses);
                        this.sectionModified({modified: false, section: UPEnums.GeneralAddresses });
                        // this.commonService.showNotification('info', res?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: true,
                          message:  res?.message
                        });
                      },
                      error: (err: any) => {
                        // this.commonService.showNotification('error', err?.error?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: false,
                          message:  err?.error?.message
                        });
                        this.usersService.apiCallCompleted(UPEnums.GeneralAddresses);
                      }
                    });
                  }
                }
                const saveGeneralProfilePic = () => {
                  if(this.generalForm.get(UPGeneralFields.userId).value) {
                  this.usersService.apiCallStarted(UPEnums.GeneralProfilePic);
                  this.usersService.saveUserPictureUrlById({
                    userId: this.generalForm.get(UPGeneralFields.userId)?.value,
                    pictureURL: this.pictureURL
                  }).subscribe({
                    next: (res: any) => {
                      // this.commonService.showNotification('info', res?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: true,
                          message:  res?.message
                        });
                      this.sectionModified({modified: false, section: UPEnums.GeneralProfilePic });
                      this.usersService.apiCallCompleted(UPEnums.GeneralProfilePic);
                    },
                    error: (err: any) => {
                      // this.commonService.showNotification('error', err?.error?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: false,
                          message:  err?.error?.message
                        });
                      this.usersService.apiCallCompleted(UPEnums.GeneralProfilePic);
                    }
                  });
                }
              }
                
                  // save all modified sections
                  saveAddresses && saveGeneralAddresses();
                  saveProfilePic && saveGeneralProfilePic();
              }
            }
          }
        });
    }
  }
  loadTimeZone() {
    const id = this.generalForm.get(UPGeneralFields.userId)?.value || this.userId;
    this.timeZone = null;
    if (!id) return;
    forkJoin([this.droApi.userTimeZone(id), this.droApi.timeZones()]).subscribe({
      next: ([view, zones]) => {
        this.timeZone = view;
        this.timeZones = zones;
        this.timeZoneValue = view.timeZoneId ?? '';
        this.timeZoneChanged = false;
      },
      error: () => this.timeZone = null,
    });
  }

  timeZoneLabel(id: string): string {
    return this.timeZones.find(z => z.id === id)?.displayName ?? id;
  }

  onTimeZoneChange(value: string) {
    this.timeZoneValue = value;
    this.timeZoneChanged = true;
    this.sectionModified({ modified: true, section: UPEnums.GeneralFormData });
  }

  private saveTimeZone(userId: string) {
    if (!this.timeZoneChanged || !this.timeZone || !userId) return;
    this.usersService.apiCallStarted('saveTimeZone');
    this.droApi.saveUserTimeZone(userId, this.timeZoneValue || null).subscribe({
      next: view => { this.timeZone = view; this.timeZoneValue = view.timeZoneId ?? ''; this.timeZoneChanged = false; this.usersService.apiCallCompleted('saveTimeZone'); },
      error: e => {
        this.usersService.apiMessages.push({ isSuccessfull: false, message: DroApiService.message(e, 'The time zone could not be saved.') });
        this.usersService.apiCallCompleted('saveTimeZone');
      },
    });
  }

  saveProfile(saveAndOption: string)  {
    this.usersService.apiCallStarted(UPEnums.GeneralFormData);
      const userId = this.generalForm.get(UPGeneralFields.userId)?.value ?? '';
      saveAndOption == 'Save & Activate' && this.generalForm.get(UPGeneralFields.isEnabled).setValue(true);
      saveAndOption == 'Save & Deactivate' && this.generalForm.get(UPGeneralFields.isEnabled).setValue(false);
      const payload = {...this.generalForm.getRawValue(), userId};
      payload.startDate = payload?.startDate != null && typeof payload.startDate == 'object' ? payload.startDate?.toISOString()?.split('Z')[0] : payload?.startDate;
      payload.endDate = payload?.endDate != null && typeof payload.endDate == 'object' ? payload.endDate?.toISOString()?.split('Z')[0] : payload?.endDate;
    this.usersService.saveGeneralSection(payload)
    .subscribe({
      next: (res: any) => {
        this.usersService.apiCallCompleted(UPEnums.GeneralFormData);
        // this.commonService.showNotification('info', res?.message);
        this.usersService.apiMessages.push({
          isSuccessfull: true,
          message:  res?.message
        });
        const oldId = this.userId;
        const newId = res?.result[UPGeneralFields.userId];
        this.generalForm.get(UPGeneralFields.userId)?.setValue(newId);
        
        this.isUserActiveOutput.emit(res?.result?.[UPGeneralFields.isEnabled]);
        this.genUserDataOutput.emit(res?.result);
        let obj: profileModificationModel = {modified: false, section: UPEnums.GeneralFormData, updatedPermissiosParameters: {category: this.source == UPEnums.SourceMyProfile ? UPEnums.MPGeneralPermission : UPEnums.UPGeneralPermission, id: this.generalForm.get(UPGeneralFields.userId)?.value}, userProfile: res?.result,  reloadSection: this.isCreatingNewUser ? 'ALL' : ''};
        (!oldId && oldId != newId) || (saveAndOption == 'Save & Activate') || (saveAndOption == 'Save & Deactivate') ? (obj.reloadSection = 'ALL') : '';
        this.sectionModified(obj);
        this.saveTimeZone(newId);
        this.isFormSubmitted = false;
        this.usersService.hasGeneralFormSavedSuccessfuly.next(true);
      },
        error: (err: any) => {
          this.modifiedUI[UPEnums.GeneralFormData] = true;
          this.usersService.apiCallCompleted(UPEnums.GeneralFormData);
          // this.commonService.showNotification('error', err?.error?.message);
            this.usersService.apiMessages.push({
              isSuccessfull: false,
              message:  err?.error?.message
            });
        }
    })
  }
setDateToZeroZero(e: any, control: string) {
  if(e?.isInteracted && e?.value) {
    const d = (new Date(new Date(e.value).setUTCHours(12, 0, 0, 0))).toISOString();
    console.log("general ====> "+control+" ====> ", d);
    this.generalForm.get(control).setValue(d);
  }
}

  removeTrailingSpaces(control: any): void {
    this.generalForm.get(control)?.setValue(this.generalForm.get(control)?.value?.trim());
  }
  sectionModified(e: profileModificationModel ) {
    if(e.section && (e.modified != null || e.modified != undefined)) {
      // console.log("UP RIMS GENERAL: sectionModified => "+ new Date().toISOString(), e.section);
      this.modifiedUI[e.section] = e.modified;
      this.usersService.hasGeneralFormChanged = this.modifiedUI[UPEnums.GeneralFormData];
    }
    this.profileModified.emit(e);
  }
  // =============================================================================================================================
  // =============================================================================================================================
  // =====================================================  COMMON FUNCTIONS ABOVE
  // =============================================================================================================================
  // =============================================================================================================================

  // ---- Addresses grid (rows held by this section, saved with the profile; up-general-addresses.grid.config.ts) ----

  // The grid, its actions and its toolbar from the section's permissions (Gen_markAddressDefault, Gen_deleteAddress,
  // Gen_addNewAddress, Gen_addressesExcelExport), as the old grid's buttons.
  buildAddressesGrid() {
    const permission = (key: string) => ({ visible: !!this.getPermission(key)?.visible, enable: !!this.getPermission(key)?.enable });
    const excel = permission('Gen_addressesExcelExport');
    const ctx = {
      makeDefault: permission('Gen_markAddressDefault'),
      remove: permission('Gen_deleteAddress'),
      add: permission('Gen_addNewAddress'),
      canExport: excel.visible && excel.enable && this.commonService.getUSER()?.role !== UserRoles.salesRep,
    };
    this.addressesGridConfig = { ...upAddressesGridConfig(ctx), toolbarActions: upAddressesToolbarActions(ctx) };
    this.addressesActionIcons = upAddressesActionIcons(ctx);
  }

  // The addresses the grid shows: every one not deleted (the old isDeleted query).
  refreshAddressRows() {
    this.addressRows.set(UP_ADDRESSES_URL, UP_ADDRESSES_SCHEMA, (this.employeeAddresses ?? []).filter((a: any) => a?.isDeleted !== true));
    this.AddressesGrid?.refresh({ keepScroll: true });
  }

  onAddressesPopupClose(rowData: any) {
    this.employeeAddresses = this.employeeAddresses ?? [];
    let foundIndex = Array.from(this.employeeAddresses).findIndex((address: any) => address['addressCode'] === rowData?.addressCode);
    if (foundIndex == -1 && typeof (rowData) != 'boolean') {
      this.showAddAddressesPopup = false;
      let payload = {
        addressCode: rowData.addressCode,
        isLNPreferred: false,
        isDefault: false,
        isDeleted: !!rowData.isDeleted,
        // other fields
        company: rowData.company,
        state: rowData.state ?? rowData.stateProvince,
        telephone: rowData.telephone,
        name: rowData.name,
        // The address search rows carry `email`; the old code read `eMail`, which they never had (the email showed empty).
        email: rowData.email ?? rowData.eMail,
        zipCode: rowData.zipCode,
        country: rowData.country,
        city: rowData.city,
        address: rowData.address
      };
      this.employeeAddresses.push(payload);
      this.usersService.setGeneralAddressCodes(this.employeeAddresses);
      this.sectionModified({modified: true, section: UPEnums.GeneralAddresses });
      this.refreshAddressRows();
    } else
      if (rowData === true) {
        this.showAddAddressesPopup = false;
      } else {
        if (this.employeeAddresses[foundIndex].isDeleted) {
          this.employeeAddresses[foundIndex].isDeleted = false;
          this.refreshAddressRows();
          this.sectionModified({modified: true, section: UPEnums.GeneralAddresses });
          this.showAddAddressesPopup = false;
        } else {
          // this.commonService.showNotification("info", "General: Already added this address.")
        }
      }
  }

  onAddressesToolbarAction(event: GridToolbarActionClickEvent) {
    if (event.key === 'addAddress') this.showAddAddressesPopup = true;
  }

  onAddressAction(event: GridActionIconClickEvent) {
    const addresses: any[] = this.employeeAddresses ?? [];
    const code = event.row['addressCode'];
    if (event.iconKey === 'delete') {
      const address = addresses.find(a => a['addressCode'] === code);
      if (!address) return;
      if (address.isDefault) {
        this.commonService.showNotification('info', 'Default addresses cannot be deleted!');
        return;
      }
      this.sectionModified({modified: true, section: UPEnums.GeneralAddresses});
      address.isDeleted = true;
    } else if (event.iconKey === 'makeDefault') {
      addresses.forEach(address => {
        if (address.addressCode == code) {
          this.sectionModified({modified: true, section: UPEnums.GeneralAddresses });
          address.isDefault = true;
        } else {
          address.isDefault = false;
        }
      });
    } else {
      return;
    }
    this.usersService.setGeneralAddressCodes(this.employeeAddresses);
    this.refreshAddressRows();
  }

  onSaveSignaturePopup(e: any) {
    this.showEditSignaturePopup = false;
    this.signatureImage = e?.modifiedSignature;
  }
  deleteUI(ui: 'Profile Picture' | 'Signature') {
    if ((ui === 'Signature' && this.isSignatureDeletable) || (ui === 'Profile Picture' && this.isProfilePictureDeletable)) {
    //  console.log("Is Pic deletable?")
      this.commonService.showConfirmation(`Are you sure you want to delete the ${ui}?`)
        .then((res: any) => {
          if (res?.isConfirmed) {
            this.usersService.apiCallStarted("deleteUI");
            let api: any;
            let payload: any = { userId: this.getFieldValue(UPGeneralFields.userId) ?? '' }
            if (ui === 'Profile Picture') {
              payload['pictureURL'] = '';
              api = this.usersService.deleteUserPictureUrlById(payload);
            } else if (ui === 'Signature') {
              payload['signature'] = ' ';
              api = this.usersService.saveUserSignatureById(payload);
            }
            api.subscribe({
              next: (res: any) => {
                if (ui === 'Profile Picture') {
                  this.sectionModified({modified: false, section: UPEnums.GeneralProfilePic });
                  this.pictureURL = res?.result?.pictureURL;
                  this.uploader.clearAll();
                } else {
                  this.signatureImage = '';
                }
                this.usersService.apiCallCompleted("deleteUI");
                // this.commonService.showNotification('info', res.message);
                this.usersService.apiMessages.push({
                  isSuccessfull: true,
                  message:  res?.message
                });
              },
              error: (err: any) => {
                // this.commonService.showNotification('error', err?.error?.message);
                this.usersService.apiMessages.push({
                  isSuccessfull: false,
                  message:  err?.error?.message
                });
                this.usersService.apiCallCompleted("deleteUI");
              }
            });
          }
        });
    }
  }


  assignNameInitialsInProfilePicture() {
    let name: string = this.generalForm?.controls[UPGeneralFields.name].value as string
    if (name) {
      let regex = /[^a-z ,A-Z]/gi;
      // name = name.replace(regex, ""); // do not restrict initials even with special characters
      let initialsArr = [];
      if (name.includes(',')) {
        initialsArr = name.split(', ');
      } else if (name.includes(' ')) {
        initialsArr = name.split(' ');
      } else {
        initialsArr = [name];
      }
      let firstChar = initialsArr[1]?.charAt(0).toLocaleUpperCase();
      let secondChar = initialsArr[0]?.charAt(0).toLocaleUpperCase();
      this.INITIALS = initialsArr.length > 1 ? secondChar + firstChar : firstChar;
    } else {
      this.INITIALS = 'N/A';
    }
  }

   beforeFileUpload(args: any) {
    this.usersService.apiCallStarted("beforeFileUpload");
    if (args.fileData.name.length > 250) {
      this.commonService.showNotification("error", "File name too long")
      args.cancel = true;
      this.usersService.apiCallCompleted("beforeFileUpload");
    } else
      if (args.fileData.size > 4300000) {
        this.commonService.showNotification("error", "Image size cannot be greater than 4mb")
        args.cancel = true;
        this.usersService.apiCallCompleted("beforeFileUpload");
      } else
        if (!(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'tif', 'heic', 'heif', 'avif'].includes(args.fileData.type))) {
          this.commonService.showNotification("error", "Please upload a valid image file (PNG, JPG, JPEG, GIF, BMP, WEBP, SVG, TIFF, HEIC, HEIF, AVIF).")
          args.cancel = true;
          this.usersService.apiCallCompleted("beforeFileUpload");
        } else {
          this.usersService.apiCallCompleted("beforeFileUpload");
          args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.authService.getToken()}`);
        }
  }

  clickAttachmentUpload(e: Event) {
    // this.usersService.apiCallStarted("uploadProfilePicture");
    (document.querySelector(`#profilePictureUpload>div>div>button`) as HTMLButtonElement)
      .click();
    e.preventDefault();
    e.stopPropagation();
  }
  onFileClear(e: any): void {
    this.uploader.clearAll(); // Resets the uploader
  }
  onUploaderCreated(uploader: UploaderComponent) {
    //
    if (uploader) {
      this.uploader = uploader;
      uploader.dropArea = document.getElementsByClassName('image-section')[0] as HTMLElement;
    }
  }
  onUploadSuccess(args: any) {
    const file = args.file;
    const response = JSON.parse(args.e.srcElement.responseText);
    if (response) {
      this.pictureURL = response.result.url;
    } else {
      console.error('Upload succeeded but URL not found in response', response.result);
    }
    this.sectionModified({modified: true, section: UPEnums.GeneralProfilePic });
  }

  onActionComplete(args: any) {
    if (args.name === 'actionComplete' && args.fileData) {  }
  }

  onGeneralEnableCheckboxChange(e: any) {
    let handleCheckbox = () => {
      if(this.generalEnableCb?.checked) {
            // this.sectionModified({modified: true, section: UPEnums.GeneralEnableCb});
            this.enableDisableApp(true);
          } else {
            this.commonService.showConfirmation("Are you sure to disable this user?")
            .then((res: any) => {
              if(res?.isConfirmed) {
                // this.sectionModified({modified: true, section: UPEnums.GeneralEnableCb});
                this.enableDisableApp(false);
              } else {
                this.generalEnableCb.checked = true;
                this.generalEnableCb.refresh();
              }
            })
          }
    }
    let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
    if(hasUnsavedChanges) {
      this.commonService.showConfirmation("Any unsaved changes will be lost, Are you sure perform this action?")
        .then(res => {
          if (res.isConfirmed) {
            handleCheckbox();
          } else {
            this.generalEnableCb.checked = !e.checked;
            this.generalEnableCb.refresh();
          }
        });
    } else {
      handleCheckbox();
    }
  }
  enableDisableApp(toggle: boolean) {
    this.usersService.apiCallStarted("enableDisableApplication");
    this.usersService.setFormsInUPService('general', toggle ? this.generalForm : null);
    this.usersService.enableDisableApplication(this.userId, '', toggle).subscribe({
      next:(res: any) => {
        this.usersService.apiCallCompleted("enableDisableApplication");
        this.sectionModified({reloadSection: 'ALL'});
        this.isSectionEnabled = toggle;
      },
      error: (err: any) => {
        this.isSectionEnabled = !toggle;
        this.generalEnableCb.checked = !toggle;
        this.commonService.showNotification("error", err?.error?.message);
        // this.sectionModified({modified: false, section: UPEnums.GeneralEnableCb});
        this.usersService.apiCallCompleted("enableDisableApplication");
      }
    });
  }
  // checkDatesFor(dateFor: 'SD' | 'ED') {
  //   return this.usersService.checkDatesFor('general', dateFor);
  // }
  setMinStartDate(e: any) { // on change of startDate
    const sd = this.generalForm.get(UPGeneralFields.startDate).value;
    this.usersService.setMinStartDate(sd);
  }
  checkDatesFor(dateFor: 'SD' | 'ED') {
    const datesValidations = this.usersService.checkDatesFor('general', dateFor);
    !this.isSectionEnabled && (datesValidations.isInvalid = false);
    return datesValidations;
  }
  ngOnDestroy() {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
    this.usersService.setFormsInUPService('destroyForm', null);
  }
}
